import { render, staticRenderFns } from "./Wallet.html?vue&type=template&id=06cf6524&scoped=true&"
import script from "./Wallet.js?vue&type=script&lang=js&"
export * from "./Wallet.js?vue&type=script&lang=js&"
import style0 from "./Wallet.scss?vue&type=style&index=0&id=06cf6524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf6524",
  null
  
)

export default component.exports